@if (!bulkWorkspaceCreation) {
  <app-create-tenant-workspace-plus-dp
    [modalMode]="modalMode"
    [tenantId]="tenantId"
    (workspaceCreated)="workspaceCreated.emit($event)"
    (cancelled)="cancelled.emit()"
  ></app-create-tenant-workspace-plus-dp>
}

@if (bulkWorkspaceCreation) {
  <div [ngClass]="{ card: !modalMode }">
    @if (!modalMode) {
      <div class="card-header">
        <h1>
          {{ 'add_workspace_and_website_app' | translate }}
        </h1>
      </div>
    }
    <div [ngClass]="{ 'card-body': !modalMode }">
      <div class="row">
        <div class="col-12">
          <h2 class="margin-bottom-md" id="header-number-of-workspaces">
            {{ 'number_of_workspaces' | translate }}
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-column align-items-start btn-group"
            role="radiogroup"
            aria-labelledby="header-number-of-workspaces"
          >
            <label class="clean-button btn border-0">
              <input type="radio" data-test-id="single-workspace-option" [(ngModel)]="singleWorkspace" [value]="true" />
              {{ 'one_workspace_and_website_app' | translate }}
            </label>
            <label class="clean-button btn border-0">
              <input type="radio" data-test-id="bulk-workspace-option" [(ngModel)]="singleWorkspace" [value]="false" />
              {{ 'multiple_workspaces_and_website_apps' | translate }}
            </label>
          </div>
        </div>
      </div>
      @if (singleWorkspace) {
        <app-create-tenant-workspace-plus-dp
          [modalMode]="modalMode"
          [singleWorkspaceOnly]="modalMode"
          [tenantId]="tenantId"
          (workspaceCreated)="workspaceCreated.emit($event)"
          (cancelled)="cancelled.emit()"
        ></app-create-tenant-workspace-plus-dp>
      }
      @if (!singleWorkspace) {
        <app-create-bulk-ws-plus-dp
          [modalMode]="modalMode"
          [tenantId]="tenantId"
          (bulkCreated)="bulkCreated.emit()"
          (cancelled)="cancelled.emit()"
        ></app-create-bulk-ws-plus-dp>
      }
    </div>
  </div>
}
